import React from "react";
import { useTheme } from "../Context/ThemeContext";
import HeaderItem from "./HeaderItem";
import Icon from "./Icon";
import Theme from "./Theme";

function Sidebar() {
    const {
        backgroundColor,
        showSidebar,
        setShowSidebar,
        colors,
        theme,
        selectedColor,
        handleColorChange,
    } = useTheme();

    return (
        <div
            className={`md:hidden top-0 right-0 w-[100vw] ${backgroundColor} px-5 py-10 text-white fixed h-full overflow-x-auto z-40 ease-in-out duration-300 border-l-2 ${
                showSidebar ? "translate-x-0 " : "translate-x-full"
            }`}
        >
            <div className="flex justify-end items-center py-2">
                <Icon
                    className="fa-solid fa-times cursor-pointer text-2xl choose-color"
                    onClick={() => setShowSidebar(!showSidebar)}
                />
            </div>
            <div className="flex flex-col justify-center items-center mt-2 py-2">
                <HeaderItem number="01." title="Home" route="/" />
            </div>
            <div className="flex flex-col justify-center items-center mt-2 py-2">
                <HeaderItem number="02." title="About" route="/about" />
            </div>
            <div className="flex flex-col justify-center items-center mt-2 py-2">
                <HeaderItem
                    number="03."
                    title="Experience"
                    route="/experience"
                />
            </div>
            <div className="flex flex-col justify-center items-center mt-2 py-2">
                <HeaderItem number="04." title="Works" route="/works" />
            </div>
            <div className="flex flex-col justify-center items-center mt-2 py-2">
                <div className="flex flex-wrap items-center justify-center gap-3">
                    {Object.entries(colors[theme].colors).map(
                        (color, index) => (
                            <div key={index} className="flex flex-wrap">
                                {typeof color === "object" && (
                                    <div
                                        className={`flex cursor-pointer mx-2 p-1 ${
                                            color[0] === selectedColor
                                                ? "border-2 border-gray-500 rounded-md"
                                                : ""
                                        }`}
                                        onClick={() => {
                                            handleColorChange(color[0]);
                                        }}
                                    >
                                        <div
                                            className={`${color[1].bgPrimary} p-5 rounded-l-md`}
                                        ></div>
                                        <div
                                            className={`${color[1].bgSecondary} p-5 rounded-r-md`}
                                        ></div>
                                    </div>
                                )}
                            </div>
                        )
                    )}
                </div>
            </div>
            <div className="flex flex-col justify-center items-center mt-2 py-2">
                <Theme />
            </div>
        </div>
    );
}

export default Sidebar;
